export default {"src":"/_next/static/media/right.46b2e6a9.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};